import { SET_SEARCH_RESULTS } from './actions';
const initialState = null;
function searchResultsReducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_SEARCH_RESULTS: {
            return payload;
        }
        default: {
            return state;
        }
    }
}
export default searchResultsReducer;
